import { Audit } from '@empathybroker/tsclient-play/dist/models/audit';
import { List } from '@empathybroker/tsclient-play/dist/models/list';

import { AuditState, GetterClass } from '../../../models';

export class DataGetter implements GetterClass {

  public static execute(state: AuditState): List<Audit> {
    return state.data;
  }

}
